<template>
  <div class="notifications-zone-bg nConfirm">  
   <div class="notifications-zone">
     <v-alert :icon="icon" :color="color">
       <v-row align="center" style="background:white;">
         <v-col class="grow" md="12" cols="12" :style="`${ small ? 'font-size: 18px;' : ''}`">{{ notificationMessage }}</v-col>
         <v-col class="grow" md="12" cols="12">
            <v-row style="float: right;" >
              <v-col class="shrink"  ><v-btn small @click="agree()" style="color: #fff !important">{{ acept }}</v-btn>
              </v-col>
            </v-row>
         </v-col>
       </v-row>
     </v-alert>
   </div>
  </div>
</template>

<script>
export default {
 props: {
   notificationMessage: String,
   type: String,
   acept: String,
   small: { type: Boolean, default: false }
 },
 data: function () {
    return {
      icon: false,
      color: ''
    }
  },
  computed: {
    typeC() {
      const type = this.type;
      if(type == 'warning')
        return 'orange';
      return type;
    }
  },
  mounted(){
    if(this.type == 'warning'){
      this.icon='mdi-alert-outline'
      this.color='#FFCC00'
    }else if(this.type == 'info'){
      this.icon='mdi-information-variant'
      this.color='#5BC0DE'
    }else{
      this.icon='mdi-close-circle-outline'
      this.color='#FF0000'
    }
  },
  methods:{
   cancel(){
    this.$emit('cancel')
   },
   agree(){
    this.$emit('agree')
   },
  }
}
</script>

<style lang="scss">
.notifications-zone-bg.nConfirm {
    position: fixed;
    height: 100vh;
    background-color: #0000001f;
    top: 0;
    left: 0;
    z-index: 998;
    width: 100%;

    .notifications-zone {
      position: fixed;
      top: 20%;
      left: 0;
      margin-left: 20%;
      z-index: 999;      
      text-align: center;
      width: 60%;
      @media(max-width: 874px) {
        width: 89%;
        margin-left: 2%;
      }

      .v-icon {
        -ms-flex-item-align: center;
        align-self: start !important;
        height: 48px;
        min-width: 48px;
        font-size: 3vh !important;
        margin-left: -6px;
      }

      .v-btn.v-btn--contained.theme--dark.v-size--default {
        background-color: #262626 !important;
        color: white !important;
      }

      .mdi:before, .mdi-set {
        font-size: 40px !important;
        font-weight: lighter;
      }
      .theme--dark.v-icon {
        //color: var(--v-primary-darken2);
      }
      .grow {
        font-size: 20px;
        //font-weight: bold;
        text-align: left;
      }
      .v-alert {
        border-color: black !important;
        width: 75%;
      }
    }    
}
@media (max-width: 874px){
    .nConfirm .col {
        width: auto !important;
    }
}

</style>